var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"brand-intro"},[_c('div',{staticClass:"logo"},[_c('img',{staticClass:"logo-top",attrs:{"src":_vm.BP_LOGO,"alt":"Logo"}})]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-initial text-center"},[_c('span',[_vm._v("A "),_c('span',{staticClass:"bp-text"},[_vm._v("BP")]),_vm._v(" tem")]),_c('span',{staticClass:"border-bottom-text"},[_vm._v("solução.")])])
}]

export { render, staticRenderFns }